// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"00b606fb","16":"a8051146","44":"80f2f7dc","130":"f10f1e52","218":"314128b4","349":"724ca45b","361":"bc05031f","590":"91b864e7","718":"d2a75118","823":"d87aa70b","881":"182cb387","898":"f31af9df","958":"90d2d898","978":"34184a06"}[chunkId] + ".chunk.js";
};